import React from 'react';
import { Card, Typography, makeStyles, Box } from '@material-ui/core';
import { AtCircularProgress } from '../../../components/AtCircularProgress';

const useStyles = makeStyles((theme) => ({
    card: {
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        padding: theme.spacing(3),
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    title: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#4B5563',
        marginBottom: theme.spacing(2),
    },
    content: {
        flex: 1,
        position: 'relative',
        minHeight: 0,
        '& .MuiCircularProgress-colorPrimary': {
            color: '#6366F1',
        },
    },
}));

const DashboardCard = ({ title, children, className, isLoading }) => {
    const classes = useStyles();
    
    return (
        <Card className={`${classes.card} ${className || ''}`} elevation={0}>
            {title && (
                <Typography className={classes.title}>
                    {title}
                </Typography>
            )}
            <Box className={classes.content}>
                {isLoading ? (
                    <AtCircularProgress />
                ) : (
                    children
                )}
            </Box>
        </Card>
    );
};

export default DashboardCard;
